//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gameNavOptions, resetTextBylangKey } from '../../../libs/options.js'
export default {
  data() {
    return {
    }
  },
  computed: {
    gameNavlist() {
      let list = resetTextBylangKey(gameNavOptions, this.$t('nav'))
      if (this.$store.state.linkList.lotteryBuySwitch === '0') list = list.filter((item) => (item.langKey !== 'Lottery'))
      return list
    }
  },
  created() {
    this.gameNavOptions = resetTextBylangKey(gameNavOptions, this.$t('nav'))
  },
  methods: {
    handleClick({ path }) { // 导航点击
      this.$router.replace({ path })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/build821/views/components/game-head/index.vue